import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Starter',
  price: '$499',
  description: 'For small consultancies getting started.',
  features: ['1 active client workspace', 'Unlimited users', 'Basic transcript-to-SOW', 'Standard document storage'],
  cta: 'Start Free Trial',
  variant: 'outline'
}, {
  name: 'Studio',
  price: '$999',
  description: 'For boutique firms with multiple consultants.',
  features: ['Up to 4 active client workspaces', 'Unlimited users', 'Advanced SOW automation', 'Full audit history & test tracking', 'Client portal access'],
  cta: 'Get Started',
  variant: 'primary',
  popular: true
}, {
  name: 'Partner',
  price: 'Custom',
  description: 'For larger practices with specific needs.',
  features: ['Unlimited client workspaces', 'Unlimited users', 'Custom SOW templates', 'API access & integrations', 'Dedicated success manager', 'SLA & Priority Support'],
  cta: 'Contact Sales',
  variant: 'outline'
}];
export function PricingSection() {
  return <section className="py-24 bg-white" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center mb-16" data-id="element-165">
          <h2 className="text-3xl font-bold text-slate-900" data-id="element-166">
            Simple, transparent pricing
          </h2>
          <p className="mt-4 text-slate-600" data-id="element-167">
            Choose the plan that fits your consultancy size.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-168">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative flex flex-col p-8 rounded-2xl border ${plan.popular ? 'border-primary-cyan/30 shadow-xl shadow-primary-blue/10 ring-1 ring-primary-cyan/20' : 'border-slate-200 shadow-sm'}`} data-id="element-169">
              {plan.popular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-170">
                  <span className="bg-gradient-primary text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-lg" data-id="element-171">
                    Most Popular
                  </span>
                </div>}

              <div className="mb-8" data-id="element-172">
                <h3 className="text-lg font-semibold text-slate-900" data-id="element-173">
                  {plan.name}
                </h3>
                <div className="mt-4 flex items-baseline text-slate-900" data-id="element-174">
                  <span className="text-4xl font-bold tracking-tight" data-id="element-175">
                    {plan.price}
                  </span>
                  {plan.price !== 'Custom' && <span className="ml-1 text-xl font-semibold text-slate-500" data-id="element-176">
                      /mo
                    </span>}
                </div>
                <p className="mt-4 text-sm text-slate-500" data-id="element-177">
                  {plan.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-178">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-179">
                    <Check className="h-5 w-5 text-accent shrink-0 mr-3" data-id="element-180" />
                    <span className="text-sm text-slate-700" data-id="element-181">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={plan.variant as any} className="w-full" onClick={() => window.open('https://calendly.com/alex-thruline/erp-client-portal', '_blank')} data-id="element-182">
                {plan.cta}
              </Button>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-183">
          <a href="https://calendly.com/alex-thruline/erp-client-portal" target="_blank" rel="noopener noreferrer" className="text-primary-blue font-medium hover:text-primary-purple flex items-center justify-center gap-2 transition-colors" data-id="element-184">
            Talk to sales about your client portfolio{' '}
            <span aria-hidden="true" data-id="element-185">→</span>
          </a>
        </div>
      </div>
    </section>;
}